import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

interface FgCardProps extends HTMLAttributes<HTMLDivElement> {
  elevated?: boolean;
  as?: keyof React.JSX.IntrinsicElements;
  children?: ReactNode;
}

/**
 * Dark glassmorphic card. The `elevated` flag brightens the surface
 * (used for the highlighted tier on the pricing page) and adds the
 * yellow-accented shadow.
 */
export function FgCard({ elevated = false, className, children, ...props }: FgCardProps) {
  return (
    <div
      className={clsx(
        "rounded-2xl",
        elevated
          ? "bg-[#1C1C1E]/95 border border-[#FFD60A]/40 shadow-[0_0_40px_rgba(255,214,10,0.15),0_24px_60px_rgba(0,0,0,0.5)] backdrop-blur-xl"
          : "bg-[#1C1C1E]/85 border border-[rgba(255,255,255,0.08)] backdrop-blur-md shadow-[0_8px_32px_rgba(0,0,0,0.25)]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
